<template>
  <b-row class="match-height justify-content-center" v-if="visits">
    <b-col
      xl="2"
      md="4"
      sm="6"
    >
      <statistic-card-vertical
        icon="EyeIcon"
        :statistic="visits.nb_visits"
        statistic-title="Visits"
        color="info"
      />
    </b-col>
    <b-col
      xl="2"
      md="4"
      sm="6"
    >
      <statistic-card-vertical
        color="warning"
        icon="BarChart2Icon"
        :statistic="visits.avg_time_on_site"
        statistic-title="Average visit duration"
      />
    </b-col>
    <b-col
      xl="2"
      md="4"
      sm="6"
    >
      <statistic-card-vertical
        color="danger"
        icon="ShoppingBagIcon"
        :statistic="visits.bounce_rate"
        statistic-title="Visits have bounced"
      />
    </b-col>
    <b-col
      xl="2"
      md="4"
      sm="6"
    >
      <statistic-card-vertical
        color="primary"
        icon="HeartIcon"
        :statistic="visits.nb_actions_per_visit"
        statistic-title="Actions"
      />
    </b-col>
    <b-col
      xl="2"
      md="4"
      sm="6"
    >
      <statistic-card-vertical
        color="success"
        icon="AwardIcon"
        :statistic="visits.max_actions"
        statistic-title="Max actions in one visit"
      />
    </b-col>
  </b-row>
</template>

<script>
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import store from '@/store'
import api from '@/libs/axios'
import { format } from 'date-fns'
import { hmError } from '@/libs/toastification'
import emitter from '@core/utils/emitter'

export default {
  components: {
    StatisticCardVertical
  },
  data() {
    return {
      visits: null
    }
  },
  methods: {
    getVisitsSummary() {
      console.log(store.state.app.idsite)
      if (!store.state.app.idsite) return
      api.post('/api/matomo/visits', {
        idSite: store.state.app.idsite,
        startDate: format(store.state.app.range.startDate, 'yyyy-MM-dd'),
        endDate: format(store.state.app.range.endDate, 'yyyy-MM-dd'),
        period: store.state.app.period
      }).then(r => {
        if (r.data.code !== 'Ok') return hmError('Error reading data')
        this.visits = r.data.visits
      })
    }
  },
  mounted() {
    this.getVisitsSummary()
    emitter.on('change_calendar', this.getVisitsSummary)
    emitter.on('change_site', this.getVisitsSummary)
  },
  beforeDestroy() {
    emitter.off('change_calendar', this.getVisitsSummary)
    emitter.off('change_site', this.getVisitsSummary)
  }
}
</script>
